import Permission from '@/modules/current-user/permissions/permissions';

/**
 * The actions that grant sharing of the org's own review of one supplier.
 *
 * Read as any-of, mirroring the backend's supplier gate, so a custom role
 * holding only the admin action keeps its access. Shared by the route's
 * `meta.permissions` and the composable gate so the two can't drift.
 */
export const SUPPLIER_SHARING_PERMISSIONS = [
  Permission.ClientsReviewSharingSupplierManage,
  Permission.ClientsReviewSharingManage,
];
